import styled from 'styled-components'

const PricePlanListUi = styled.div`
  display: grid;
  gap: 20px;
`

export default PricePlanListUi
